import { render, staticRenderFns } from "./DuaMessageError.vue?vue&type=template&id=2b02cd93"
import script from "./DuaMessageError.vue?vue&type=script&lang=js"
export * from "./DuaMessageError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports